import { Component, OnInit } from '@angular/core';
import { Filtering } from '../../../service/filtering/filtering';
import { RequestHandler } from '../../../service/OffService/request-handler';
import { RequestButtonTypes } from '../../../common/components/request-button/request-button.component';
import { DashboardService } from '../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { BaseView } from '../../base-view';
import { UsuariosApiService } from '../../../service/api/usuarios-api.service';
import { environment } from '../../../../environments/environment';
import {StorageManager} from '../../../common/storage-manager.class';
import { getBackNameCountry } from '../../../common/country';
import { createCsv, createCsvField } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import type { FormField } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { UserApiService } from '../../../service/api/user-api.service';

import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { UserModel } from 'src/app/models/usuarios/user.model';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';

import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { UsuariosListModalFormDefinition } from './usuarios-form/form-control/list-modal-form-definition';
@Component({
    selector: 'app-usuarios',
    standalone: false,
    templateUrl: './usuarios.component.html',
    styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent extends BaseView<UserModel> implements OnInit {
    public serverUrl = environment.serverUrl;

    public form: UsuariosListModalFormDefinition | null = null;


    public showPerfilUnidades = environment.features.showPerfilUnidades;
    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public canRegister = environment.features.canRegister;
    public btnAnadir = 'Añadir Usuario';

    public filter: Filtering<UserModel> = new Filtering<UserModel>();
    public getRequest: RequestHandler<UserModel[]> = this.usuariosApi.usuariosGET;
    public deleteRequest: RequestHandler<UserModel> = this.usuariosApi.usuariosDELETE;
    public pathToForm = 'usuarios-form';
    public menuItemId = 'usuarios';
    public currentUser = StorageManager.getUser();

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model = {} as UserModel;

    public formFieldsDatosCuenta: FormField<any>[] = [
        createCsvField<any>('username', 'Nombre de Usuario'),
        createCsvField<any>('tipo', 'Tipo'),
        createCsvField<any>('acceso_plataforma', 'Acceso a Plataforma'),
    ];

    public formFieldsDatosPersonales: FormField<any>[] = [

        createCsvField<any>('nombre', 'Nombre'),
        createCsvField<any>('apellidos', 'Apellidos'),
        createCsvField<any>('nif', 'NIF\xa0/\xa0CIF'),
        createCsvField<any>('email', 'Email'),
        createCsvField<any>('telefono', 'Teléfono'),
    ];

    public formFields: FormField<any>[] = [
        createCsvField<any>('email', 'Email'),
        createCsvField<any>('nombre', 'Nombre'),
        createCsvField<any>('apellidos', 'Apellidos'),
        createCsvField<any>('tipo_carnet', 'Tipo de carnet'),
        createCsvField<any>('fecha_caducidad', 'Fecha de caducidad'),
        createCsvField<any>('nif', 'NIF'),
        createCsvField<any>('ropo', 'ROPO'),
        createCsvField<any>('uds_medida', 'Unidad de medida', InputType.TEXT, this.showPerfilUnidades),
        createCsvField<any>('ratio_ha', 'Relación con una hectárea', InputType.TEXT, this.showPerfilUnidades),
        createCsvField<any>('tipo_mando', 'Tipo de mando', InputType.TEXT, this.appName === 'manezylozano'),
        createCsvField<any>('imei', 'IMEI', InputType.TEXT, this.appName === 'manezylozano'),
        createCsvField<any>('pais', 'País', InputType.TEXT, this.appName === 'manezylozano')
    ];

    public colsCanRegister: ColInterface[] = [
        {
            field: 'nombre', 
            header: 'Nombre', 
            filter: '', 
            width: '12.5rem'
        },
        {
            field: 'nif', 
            header: 'NIF\xa0/\xa0CIF', 
            filter: '',
            width: '8rem'
        },
        {
            field: 'email', 
            header: 'Email', 
            filter: '', 
            width: '8rem'
        },
        {
            field: 'telefono', 
            header: 'Teléfono', 
            filter: '',
            width: '8rem'
        },
        {
            field: 'tipo', 
            header: 'Tipo', 
            filter: '', 
            width: '8rem'
        },
    ];

    public cols: ColInterface[] = [
        {
            field: 'nombre', 
            header: 'Nombre', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'apellidos', 
            header: 'Apellidos', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'tipo_carnet', 
            header: 'Carnet', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'fecha_caducidad', 
            header: 'Caducidad', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'nif', 
            header: 'NIF', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'ropo', 
            header: 'ROPO', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'email', 
            header: 'Email', 
            filter: '',
            width: '5rem'
        }
    ];

    constructor(public usuariosApi: UsuariosApiService,
        public userApi: UserApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, usuariosApi.usuariosGET, usuariosApi.usuariosDELETE);
    }


    public override show(modal: string, data: UserModel): void {
        super.show(modal, data);
        this.setModalForm(modal);
    }

    ngOnInit() {
        this.dashboard.setMenuItem(this.menuItemId);
    }

    public add() {
        this.router.navigate(['dashboard', 'crear-usuario']);
    }

    public edit(data: UserModel) {
        if (data.id === this.currentUser.id) {
            this.dashboard.openProfileDialog();
        } else {
            this.router.navigate(['dashboard', 'editar-usuario', data.id]);
        }
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<UserModel>) {
        const user = row.data as UserModel; 
        if (col.field === 'nombre'){
            if (user.apellidos === null) {
                user.apellidos = '';
            }
            return user.nombre + ' ' + user.apellidos;
        }
        if (col.field === 'tipo') {
            if (user.tipo === 'comunero' && (this.appName !== 'sequiador'  && this.appName !== 'SIEX')) {
                return 'agricultor';
            }
            if (user.rol === 'responsable' && this.appName === 'avafitogest') {
                return 'técnico';
            }
            if (user.rol === 'responsable' && this.appName === 'benibal') {
                return 'asesor';
            }
            if (user.rol === 'admin') {
                return 'admin';
            }
        }
        return value;
    }
    public globalConditionalStyle(
        _value: string, 
        _col: ColInterface, 
        _colGroup: ColInterface[], 
        row: TreeNode<UserModel>
    ): ColStylesInterface {
        const user = row.data as UserModel;
        if ( this.appName === 'manezylozano') {
            user.pais = (user.pais ? getBackNameCountry(user.pais) : '') ?? '';
        }
        return {};
    }

    public getStyles(property: string, data: UserModel) {
        if (property === 'acceso_plataforma' && data.acceso_plataforma) {
            switch (parseInt(data.acceso_plataforma, 10)) {
            case 0: return { backgroundColor: '#e91224' }; // Inactivo: rojo
            case 1: return { backgroundColor: '#34a835' }; // Activo: verde
            case 2: return { backgroundColor: '#FFFFFF' }; // Pendiente: azul
            }
        }
        return;
    }

    public toggleActive(data: UserModel) {
        if (confirm('¿Desea activar/desactivar este usuario? \n Este será notificado de ello por email.')) {
            if (data && data.acceso_plataforma) {
                if (data.acceso_plataforma === '2') {
                    data.acceso_plataforma = '1'; // Activo
                } else if (data.acceso_plataforma === '1') {
                    data.acceso_plataforma = '0'; // Inactivo
                } else {
                    data.acceso_plataforma = '1'; // Activo
                }
            }

            this.userApi.sendEmailConfirmation({
                usuario: data.username,
                email: data.email,
                estado: data.acceso_plataforma
            } as UserModel).then(res => {
                console.log(res);
                return;
            }
            ).catch (e => {
                console.log('catch en sendEmailConfirmation: ' + e);
            }
            );

            this.usuariosApi.usuariosPUT.perform({
                id: data.id,
                id_state: data.acceso_plataforma
            } as never);
            this.usuariosApi.usuariosPUT.response(res => {
                const respuesta: unknown = res;
                if ((respuesta as Response).status === 200) {
                    console.log('Success!');
                }
            });

        }
    }

    public async exportarUsuarios() {
        window.location.replace(environment.serverUrl + 'fito_backup/exportar_usuarios.php');
    }

    public async downloadCsv() {

        const arrayFormFields = [
            this.formFieldsDatosCuenta,
            this.formFieldsDatosPersonales
        ];
  
    
        const csvFields = arrayFormFields
            .flat()
            .filter((field) => field.conditions.isVisible && field.input.type !== InputType.EMPTY);

        const csvContent = createCsv(csvFields, csvFields.map((field) => field.label), this.filter.value as UserModel[]);
  
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Usuarios.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }// if();
    }// ();
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new UsuariosListModalFormDefinition(formType, this.model, this);
    }

}
